module.exports = __webpack_public_path__ + "static/img/log.1b059c90.png";